export class Secagem {
    public cdfazenda: number;
    public cdmatriz: number;
    public nome: string;
    public numero: string;
    public cdreproducao: number;
    public dtsecagem: Date;
    public dtparto: Date;
    public checked: boolean;
}